// confirm + re-authenticate before permanently deleting the user's account
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { deleteAccount, closeModal } from '../../actions';
import CircularLoadingButton from '../commoncomponents/CircularLoadingButton';
import {
  deleteAccountType,
  closeModalType,
  loadingType,
  classesType,
  providerDataType
} from '../../types';

const styles = {
  wrapper: {
    position: 'relative'
  },
  dialogActions: {
    padding: '1rem'
  },
  confirmField: {
    marginTop: '1rem'
  }
};

class DeleteAccountModal extends Component {
  state = {
    password: ''
  };

  handlePassword = e => {
    this.setState({ password: e.target.value });
  };

  // password users must re-enter their password; google users re-auth via popup
  usesPassword = () => {
    return this.props.providerData.some(
      provider => provider.providerId === 'password'
    );
  };

  handleDelete = async () => {
    // on success the thunk signs the user out and closes this modal; on failure
    // it shows an error snackbar and leaves the modal open so they can retry
    await this.props.deleteAccount(this.state.password);
  };

  render() {
    const { loading, classes } = this.props;
    const { password } = this.state;
    const usesPassword = this.usesPassword();
    const confirmDisabled = loading || (usesPassword && password.length === 0);

    return (
      <Dialog
        open
        onClose={this.props.closeModal}
        aria-labelledby="delete-account-dialog-title"
        aria-describedby="delete-account-dialog-description"
      >
        <DialogTitle id="delete-account-dialog-title">
          Delete Account
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-account-dialog-description">
            This permanently deletes your account and profile and cannot be
            undone. Your prompts and messages will remain but will show as
            &quot;[deleted]&quot; to other people.
          </DialogContentText>
          {usesPassword ? (
            <TextField
              autoFocus
              fullWidth
              id="delete_account_password"
              label="Enter your password to confirm"
              type="password"
              value={password}
              onChange={this.handlePassword}
              className={classes.confirmField}
            />
          ) : (
            <DialogContentText className={classes.confirmField}>
              You&apos;ll be asked to sign in with Google again to confirm.
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={this.props.closeModal} disabled={loading}>
            Cancel
          </Button>
          <div className={classes.wrapper}>
            <Button
              onClick={this.handleDelete}
              color="error"
              variant="contained"
              disabled={confirmDisabled}
            >
              Delete my account
            </Button>
            {loading && <CircularLoadingButton />}
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}

DeleteAccountModal.propTypes = {
  deleteAccount: deleteAccountType.isRequired,
  closeModal: closeModalType.isRequired,
  loading: loadingType.isRequired,
  classes: classesType.isRequired,
  providerData: providerDataType.isRequired
};

const mapStateToProps = ({ async: { loading }, auth: { providerData } }) => {
  return { loading, providerData };
};

const actions = { deleteAccount, closeModal };

const enhance = compose(connect(mapStateToProps, actions), withStyles(styles));

export default enhance(DeleteAccountModal);
